import { render, staticRenderFns } from "./MvpAnnouncement.vue?vue&type=template&id=f2f05cf4&scoped=true&"
import script from "./MvpAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MvpAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./MvpAnnouncement.vue?vue&type=style&index=0&id=f2f05cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f05cf4",
  null
  
)

export default component.exports